import { store, isCloudCacheLoaded } from '../store/store';
import { isFeatureEnabled } from 'owa-feature-flags';
import { logUsage } from 'owa-analytics';
import { DatapointVariant } from 'owa-analytics-types';
import { isEasiIdUser } from './isEasiIdUser';

export function isEasiIdUserWithoutCloudCache() {
    if (!isEasiIdUser()) {
        return false;
    }

    // it is necessary to check if cloudcache is loaded before believe that we
    // have a valid information.
    if (!isCloudCacheLoaded()) {
        return false;
    }

    let logUsageText = {
        userWithCC: 'isEasiIdGmailUserWithCloudCache',
        userWithoutCC: 'isEasiIdGmailUserWithoutCloudCache',
    };

    if (isFeatureEnabled('growth-easiIdGmailCloudCacheV2')) {
        logUsageText = {
            userWithCC: 'isEasiIdGmailUserWithCloudCacheV2',
            userWithoutCC: 'isEasiIdGmailUserWithoutCloudCacheV2',
        };
    }

    if (store.cloudCacheConfigItem.emailAddress) {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2345 (34,43): Argument of type 'null' is not assignable to parameter of type 'CustomData | undefined'.
        // @ts-expect-error
        logUsage(logUsageText.userWithCC, null, {
            // this function is called more than once per session,
            // so we added this flag to log only the first datapoint
            variant: DatapointVariant.WarmOnly,
            isCore: true,
        });

        return false;
    }

    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2345 (47,42): Argument of type 'null' is not assignable to parameter of type 'CustomData | undefined'.
    // @ts-expect-error
    logUsage(logUsageText.userWithoutCC, null, {
        variant: DatapointVariant.WarmOnly,
        isCore: true,
    });

    return true;
}
